import { TournamentOpen } from 'actions/actionTypes';

export const resetTournamentData = () => ({ type: TournamentOpen.RESET_TOURNAMENT_DATA });
export const changeTournamentOpenStep = (step) => ({ type: TournamentOpen.CHANGE_TOURNAMENT_OPEN_STEP, payload: step });
export const catchTournamentParams = (value) => ({ type: TournamentOpen.CATCH_TOURNAMENT_PARAMS, payload: { value } });
export const changeTournamentData = (name, value) => ({ type: TournamentOpen.CHANGE_TOURNAMENT_DATA, payload: { name, value } });
export const changeTournamentParticipationTargetsData = (index, name, value) => ({
  type: TournamentOpen.CHANGE_TOURNAMENT_PARTICIPATION_TARGETS_DATA,
  payload: { index, name, value },
});
export const resetTournamentParticipationTargetsData = () => ({ type: TournamentOpen.RESET_TOURNAMENT_PARTICIPATION_TARGETS_DATA });
export const changeTournamentParticipationGradessData = (index, name, value) => ({
  type: TournamentOpen.CHANGE_TOURNAMENT_PARTICIPATION_GRADES_DATA,
  payload: { index, name, value },
});
export const changeTournamentCourseRoundsData = (index, name, value, newPerioIndex) => ({
  type: TournamentOpen.CHANGE_TOURNAMENT_COURSE_ROUNDS_DATA,
  payload: { index, name, value, newPerioIndex },
});
export const changeTournamentAwardsData = (index, name, value) => ({ type: TournamentOpen.CHANGE_TOURNAMENT_AWARDS_DATA, payload: { index, name, value } });
export const changeTournamentParticipatingStoresData = (index, name, value) => ({
  type: TournamentOpen.CHANGE_TOURNAMENT_PARTICIPATIONSHOPS_DATA,
  payload: { index, name, value },
});
export const changeTournamentId = (id) => ({ type: TournamentOpen.CHANGE_TOURNAMENT_ID, payload: { id } });
export const changeTournamentParticipationGradeListItem = (item) => ({
  type: TournamentOpen.CHANGE_TOURNAMENT_PARTICIPATION_GRADE_LIST_ITEM,
  payload: { ...item },
});
export const changeTournamentIsParticipationGradeAllChecked = (value, isReset) => ({
  type: TournamentOpen.CHANGE_TOURNAMENT_IS_PARTICIPATION_GRADE_ALL_CHECKED,
  payload: { value, isReset },
});

export const loadShopTournamentRawDataRequest = () => ({ type: TournamentOpen.LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST });
export const loadShopTournamentRawDataRequestSuccess = (responseData) => ({
  type: TournamentOpen.LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST_SUCCESS,
  payload: responseData,
});
export const loadShopTournamentRawDataRequestFailure = (errorMessage) => ({
  type: TournamentOpen.LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST_FAILURE,
  payload: errorMessage,
});

export const loadShopTournamentTermsRequest = () => ({ type: TournamentOpen.LOAD_SHOP_TOURNAMENT_TERMS_REQUEST });
export const loadShopTournamentTermsRequestSuccess = (responseData) => ({
  type: TournamentOpen.LOAD_SHOP_TOURNAMENT_TERMS_REQUEST_SUCCESS,
  payload: responseData,
});
export const loadShopTournamentTermsRequestFailure = (errorMessage) => ({
  type: TournamentOpen.LOAD_SHOP_TOURNAMENT_TERMS_REQUEST_FAILURE,
  payload: errorMessage,
});

export const loadShopTournamentCourseListRequest = () => ({ type: TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST });
export const loadShopTournamentCourseListRequestSuccess = (responseData) => ({
  type: TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST_SUCCESS,
  payload: responseData,
});
export const loadShopTournamentCourseListRequestFailure = (errorMessage) => ({
  type: TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST_FAILURE,
  payload: errorMessage,
});

export const loadShopTournamentCourseDetailsRequest = () => ({ type: TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST });
export const loadShopTournamentCourseDetailsRequestSuccess = (responseData) => ({
  type: TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST_SUCCESS,
  payload: responseData,
});
export const loadShopTournamentCourseDetailsRequestFailure = (errorMessage) => ({
  type: TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST_FAILURE,
  payload: errorMessage,
});

export const addShopTournamentRequest = () => ({ type: TournamentOpen.ADD_SHOP_TOURNAMENT_REQUEST });
export const addShopTournamentRequestSuccess = (responseData) => ({ type: TournamentOpen.ADD_SHOP_TOURNAMENT_REQUEST_SUCCESS, payload: responseData });
export const addShopTournamentRequestFailure = (errorData) => ({ type: TournamentOpen.ADD_SHOP_TOURNAMENT_REQUEST_FAILURE, payload: errorData });

export const modifyShopTournamentRequest = () => ({ type: TournamentOpen.MODIFY_SHOP_TOURNAMENT_REQUEST });
export const modifyShopTournamentRequestSuccess = (responseData) => ({ type: TournamentOpen.MODIFY_SHOP_TOURNAMENT_REQUEST_SUCCESS, payload: responseData });
export const modifyShopTournamentRequestFailure = (errorMessage) => ({ type: TournamentOpen.MODIFY_SHOP_TOURNAMENT_REQUEST_FAILURE, payload: errorMessage });
